import Vue from 'vue'

export default {
  list (config = {}) {
    return Vue.http.get('/rental/products', {
      ...config
    })
  },

  get (id, config = {}) {
    return Vue.http.get(`/rental/products/${id}`, {
      ...config
    })
  },

  getAll (config = {}) {
    return Vue.http.get('/rental/product_sales', {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/rental/product.js